// CRC-32 (IEEE 802.3), the checksum ZIP requires on every entry. Kept in
// its own module because it is the one piece of the zip writer that is a
// published constant rather than an encoding decision: crc32("123456789")
// is 0xCBF43926 in every implementation, which is what its test pins.

let table: Uint32Array | null = null;

function crcTable(): Uint32Array {
  if (table) return table;
  const t = new Uint32Array(256);
  for (let i = 0; i < 256; i++) {
    let c = i;
    for (let bit = 0; bit < 8; bit++) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    t[i] = c >>> 0;
  }
  table = t;
  return t;
}

export const CRC32 = {
  of(bytes: Uint8Array): number {
    const t = crcTable();
    let crc = 0xffffffff;
    for (let i = 0; i < bytes.length; i++) {
      crc = t[(crc ^ bytes[i]) & 0xff] ^ (crc >>> 8);
    }
    return (crc ^ 0xffffffff) >>> 0;
  },
};
